import React from 'react';

export const MobileNavigation = (props) => {
  
  const {currentSlide, totalSlides} = props;

  return (
    <div className="d-flex d-md-none splide__arrows">
      <button className="btn splide__arrow splide__arrow--prev">
        <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
          <g clipPath="url(#clip0_2311_1134)">
            <path d="M25 12L1 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M8 19L1 12L8 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_2311_1134">
              <rect width="26" height="24" fill="white" transform="translate(26 24) rotate(-180)"/>
            </clipPath>
          </defs>
        </svg>
      </button>
      <div className="d-inline-flex align-items-center">
        <span className="splide__current">{currentSlide}</span>
        <span className="splide__total">{totalSlides}</span>
      </div>
      <button className="btn splide__arrow splide__arrow--next">
        <svg width="26" height="24" viewBox="0 0 26 24" fill="none">
          <g clipPath="url(#clip0_2311_1139)">
            <path d="M1 12L25 12" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
            <path d="M18 19L25 12L18 5" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"
                  strokeLinejoin="round"/>
          </g>
          <defs>
            <clipPath id="clip0_2311_1139">
              <rect width="26" height="24" fill="white"
                    transform="matrix(1 -8.74228e-08 -8.74228e-08 -1 0 24)"/>
            </clipPath>
          </defs>
        </svg>
      </button>
    </div>
  )
}